<template>
    <div class="modal-content-footer">
        <ActionButton :text="$t('Cancel')" @click="close" />
        <ActionButton
            :text="$t('Log out')"
            style-type="primary-brand-filled"
            icon="fas fa-sign-out-alt"
            icon-position="left"
            @click="logout"
        />
    </div>
</template>

<script lang="ts">
import { AuthController } from "@/control/auth";
import { defineComponent } from "vue";
import ActionButton from "@/components/buttons/ActionButton.vue";

export default defineComponent({
    components: {
        ActionButton,
    },
    name: "LogoutModalContent",
    emits: ["close-modal"],
    methods: {
        close: function () {
            this.$emit("close-modal");
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.close();
            }
        },

        logout: function () {
            this.close();
            const router = this.$router;
            AuthController.Logout().then(() => {
                router.push({ name: "login" });
            });
        },
    },
});
</script>
